import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { EnvironmentService } from "./environment.service";
import { ActionResult, RaceRegistration, ConfirmPayment} from "@model";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RaceRegistrationService {
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  findRegistrationByCompetitorID(competitorId: number): Observable<RaceRegistration | undefined> {
    return this.http.post<ActionResult<RaceRegistration>>(
      `${this.environmentService.getApiUrl()}/api/registration/bycompetitorid`, competitorId
    ).pipe(
      map(actionResult => actionResult.resultCode !== -1 ? actionResult.result : undefined)
    );
  }

  confirmRegistration(confirmPayment: ConfirmPayment,onSuccess?: () => void, onError?: () => void): void {
    let url: string | null = null;

    if (confirmPayment.registrationId) {
      url = `${this.environmentService.getApiUrl()}/api/races/confirmPayment/registrationId/${confirmPayment.registrationId}`;
    } else if (confirmPayment.competitorId) {
      url = `${this.environmentService.getApiUrl()}/api/races/confirmPaymentLegacy/competitorId/${confirmPayment.competitorId}`;
    }

    if (url) {
      this.http.post<void>(url, confirmPayment).subscribe({
        next: () => {
          if (onSuccess) onSuccess();
        },
        error: () => {
          if (onError) onError();
        }
      });
    } else {
      if (onError) onError();
    }
  }

}
